import api from './desktopProperties.api'

import { GET_DESKTOP_PROPERTIES, PUT_DESKTOP_PROPERTIES } from './desktopProperties.constants'
import { createApiAction } from '../../Helpers/actions'

export const getDesktopProperties = (properties, tenantId) =>
  createApiAction(GET_DESKTOP_PROPERTIES, api.getDesktopProperties)([properties, tenantId])

export const putDesktopProperties = createApiAction(PUT_DESKTOP_PROPERTIES, api.putDesktopProperties)
